import script from "./TopologyStatsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopologyStatsView.vue?vue&type=script&setup=true&lang=ts"

import "./TopologyStatsView.vue?vue&type=style&index=0&id=34b2b3a8&lang=css"

const __exports__ = script;

export default __exports__